/**
 * UBL Hook for Product Swatch Carousel
 *
 * @description PDP Color Swatch - color swatch CTR 측정을 위한 노출/클릭 로깅
 * @notion https://www.notion.so/croquis/PDP-Color-Swatch-2ca3dd4dd5b180bcb5dee74b4d745552
 */
import { useUBL, useUBLContext } from '@common/log-manager';

interface ColorSwatchUBLParams {
  /** color_swatch에 노출되는 상품ID */
  catalog_product_id: string;
  /** 아이템 인덱스 (왼→오 0, 1, 2, 3 ..) */
  item_idx: number;
  /** L2_winner PDP의 상품ID */
  original_product_id: string;
}

export const useProductSwatchCarouselUBL = () => {
  const sendUBL = useUBL();
  const ublContext = useUBLContext();

  const navigation = ublContext.navigation ?? 'product_detail';

  /** PDP > color swatch 노출 */
  const colorSwatchImpressionUBL = ({ catalog_product_id, item_idx, original_product_id }: ColorSwatchUBLParams) => {
    sendUBL({
      navigation,
      category: 'impression',
      object_section: 'color_swatch',
      object_type: 'catalog',
      object_id: catalog_product_id,
      object_idx: item_idx,
      data: {
        original_product_id,
      },
    });
  };

  /** PDP > color swatch 클릭 */
  const colorSwatchClickUBL = ({ catalog_product_id, item_idx, original_product_id }: ColorSwatchUBLParams) => {
    sendUBL({
      navigation,
      category: 'click',
      object_section: 'color_swatch',
      object_type: 'catalog',
      object_id: catalog_product_id,
      object_idx: item_idx,
      data: {
        original_product_id,
      },
    });
  };

  return {
    colorSwatchImpressionUBL,
    colorSwatchClickUBL,
  };
};
